import { render, staticRenderFns } from "./TheLandingDrawer.vue?vue&type=template&id=45c8141a&"
import script from "./TheLandingDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheLandingDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports